var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roma-page-content fill-height bg-white"},[_c('EvaluationsHeader',{attrs:{"title":"Mis evaluaciones por tomar"}}),_c('EvaluationsContent',{attrs:{"items":8}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }